/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RequestReplacementApiModel } from '../../models/request-replacement-api-model';

export interface RequestReplacement$Params {
      body: RequestReplacementApiModel
}

export function requestReplacement(http: HttpClient, rootUrl: string, params: RequestReplacement$Params, context?: HttpContext): Observable<StrictHttpResponse<RequestReplacementApiModel>> {
  const rb = new RequestBuilder(rootUrl, requestReplacement.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RequestReplacementApiModel>;
    })
  );
}

requestReplacement.PATH = '/leads/replacement';
